import React from "react";
import BaseIconButton from "./BaseIconButton";
import BackIcon from "react-icons/lib/md/chevron-left";

type Props = {
  [other: string]: any;
};

export function BackButton(props: Props) {
  return (
    <BaseIconButton leftIcon={<BackIcon />} {...props}>
      {props.children}
    </BaseIconButton>
  );
}
